import { useEffect } from 'react';
import { useRouteError } from 'react-router';

import { UpdateRequired } from '@/components/templates/common/UpdateRequired/UpdateRequired';
import useRouter from '@/hooks/useRouter';
import useTranslation from '@/hooks/useTranslation';
import { isBuildRecoveryError } from '@/utils/buildRecovery';

function RouteErrorBoundary() {
  const t = useTranslation('common');
  const error = useRouteError();
  const { redirectToLogin } = useRouter();

  useEffect(() => {
    if (
      error &&
      typeof error === 'object' &&
      'statusCode' in error &&
      error.statusCode === 401
    ) {
      redirectToLogin();
    }
  }, [error, redirectToLogin]);

  if (isBuildRecoveryError(error)) {
    return <UpdateRequired />;
  }

  const errorMessage =
    error && typeof error === 'object'
      ? ('statusText' in error &&
          typeof error.statusText === 'string' &&
          error.statusText) ||
        ('message' in error && typeof error.message === 'string'
          ? error.message
          : undefined)
      : undefined;

  return (
    <div role="alert">
      <h1>{t('errors.fatal.title')}</h1>
      <p>{t('errors.fatal.subtitle')}</p>
      {errorMessage && <p>{errorMessage}</p>}
    </div>
  );
}

export default RouteErrorBoundary;
